<template>
    <Form :model="formData" :label-width="100"  :rules="formRules" ref="formData">
        <FormItem label="功能区名称" prop="name">
            <Input v-model="formData.name" class="item-width" ></Input>
        </FormItem>

        <FormItem label="面积（㎡）" prop="area">
            <Input v-model="formData.area" class="item-width" :number="true"></Input>
        </FormItem>
        <FormItem label="项目" prop="projectId">
            <Select v-model="formData.projectId" class="item-width" @on-change="changeProject">
              <Option value="">请选择</Option>
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="楼栋" prop="buildingId">
            <Select v-model="formData.buildingId" class="item-width"  @on-change="changBuiding">
              <Option value="">{{formData.projectId !==''?(buildingsList.length===0?'暂无数据':'请选择'):'请先选择项目'}}</Option>
                <Option v-for="item in buildingsList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="楼层" prop="floor">
            <Select v-model="formData.floor" class="item-width" >
              <Option value="">{{floorList.length===0?'请先选择楼栋':'请选择'}}</Option>
                <Option v-for="item in floorList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
    </Form>
</template>
 
<script type="text/ecmascript-6">
export default {
    props: {
        n:{
            type:Number,
            default:0
        },
        initFormData:{
            type:Object,
            default:null
        },
        projectList:{
            type:Array,
            default:null
        }
    },
    created(){
      
    },
    watch: {
      n(){
        this.$refs['formData'].resetFields();
        if(this.initFormData){
            for (var key in this.initFormData) {
                this.formData[key] = this.initFormData[key]
            }
            this.formData.area = parseInt(this.formData.area)
        }
      } 
    },
    data () {
        const validateArea = (rule, value, callback) => {
          if(!value){
            callback(new Error('面积不能为空'));
          }
          if(typeof value === 'string'){
            callback(new Error('请输入正确的面积数'));
          }
          if(value <= 0){
              callback(new Error('面积应大于于0'));
          }
          callback();
        }
        return {
          buildingsList:[],
          floorList:[],
          formData:{
              fid:'',
              name:'',
              area:'',
              projectId:'',
              buildingId:'',
              floor:''
          },   
          formRules:{
              name:[
                { required: true, message: '请输入功能区名称' ,trigger: 'blur', type:'string'}
              ],
              area:[
                  {required:true, validator: validateArea, trigger: 'blur'}
                
              ],
              projectId:[
                  { required: true, type:'string', message: '请选择项目', trigger: 'change' }
              ],
              buildingId:[
                  {required:true, message: '请选楼栋', trigger: 'change'}
              ],
              floor:[
                  {required:true, type:"number", message: '请选楼层', trigger: 'change'}
              ]
          }
        }
    },
    methods: {
        formValidate() {     
            let obj = null;
            this.$refs['formData'].validate( bool => {
                if(bool){
                    obj = this.formData;
                }else{
                    obj = false
                }
            })
            return obj
        },
        changeProject(value) {
          for (let [index, item] of this.projectList.entries()) {
          if (value === item.value) {
              this.buildingsList = this.projectList[index].children;
          }
          }
          if(!this.formData.projectId){
            this.buildingsList=[]
          }
          // this.formData.buildingId = ''
          this.floorList=[]    
        },
        changBuiding(value) {
          for (let [index, item] of this.buildingsList.entries()) {
            if (value === item.value) {              
              this.floorList = this.buildingsList[index].children; 
            }
          }
          if(!this.formData.buildingId){
            this.floorList=[]
          }    
        }
    }
}
</script>
 
<style lang="css" scoped>
.item-width{
    width: 200px;
}
.area-width{
    width: 324px;
}
</style>